import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NextStepIconSvg from './icon-next-step.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NextStepIconSvg {...validProps} />;
}
SvgComponent.iconName = 'nextStepIcon';

/**
 * @deprecated This is a legacy icon
 */
export const NextStepIcon = svgIconWrapper(SvgComponent);
